import { useStorage } from '~/hooks/use-storage'
import { z } from 'zod'

export const installerSchema = z.union([
  z.literal('yarn'),
  z.literal('npm'),
  z.literal('pnpm'),
])
export type Installer = z.infer<typeof installerSchema>
export const frameworks = [
  'Next.js',
  'Remix',
  'SvelteKit',
  'Astro',
  'Vue.js',
] as const
export const frameworkSchema = z.enum(frameworks)
export type Framework = z.infer<typeof frameworkSchema>

export interface ConnectStore {
  installer: Installer
  framework: Framework
  setFramework: (framework: Framework) => void
  setInstaller: (installer: Installer) => void
}

export const useConnectStore = () => {
  return useStorage(
    'localStorage',
    (z) =>
      z.object({
        installer: installerSchema,
        framework: frameworkSchema,
      }),
    `connect-preferences`,
    {
      initialValue: {
        installer: 'npm',
        framework: 'Next.js',
      } as const,
    }
  )
}
